import { render } from "./Servicos.vue?vue&type=template&id=898395ba&scoped=true"
import script from "./Servicos.vue?vue&type=script&lang=js"
export * from "./Servicos.vue?vue&type=script&lang=js"

import "./Servicos.vue?vue&type=style&index=0&id=898395ba&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-898395ba"]])

export default __exports__